/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//French (France)
export default {
  'team-central.give-jira-kudos.created.description.flag': 'Notre équipe Workplace Experience va maintenant faire tout son possible pour répondre à la demande de cadeau. ✨',
  'team-central.give-jira-kudos.created.title.flag': 'Félicitations créées',
  'team-central.give-jira-kudos.creation.failed.description.flag': "Nous avons envoyé les félicitations, mais nous n'avons pas pu envoyer le cadeau en raison d'une erreur. Veuillez créer un ticket distinct sur <a>go/kudos</a>.",
  'team-central.give-jira-kudos.creation.failed.title.flag': "Impossible d'envoyer le cadeau",
  'team-central.give-kudos.button': 'Féliciter',
  'team-central.give-kudos.close-button.label': 'Fermer le tiroir',
  'team-central.give-kudos.confirm-close.title': 'Confirmer la fermeture',
  'team-central.give-kudos.created.description.flag': 'Vos félicitations ont été envoyées. <a>Voir les félicitations</a>',
  'team-central.give-kudos.created.title.flag': 'Félicitations créées',
  'team-central.give-kudos.success-icon.label': 'Opération réussie',
  'team-central.give-kudos.unsaved.warning': 'Les changements effectués ne seront pas enregistrés.',
  'team-central.give-kudos.unsaved.warning.cancel': 'Annuler',
  'team-central.give-kudos.unsaved.warning.close': 'Fermer'
};